<template>
  <v-app>
    <v-app-bar fixed color="rgba(40,36,61,0.95)" flat height="90">
      <v-img :src="logo" max-width="65px" alt="logo" contain eager></v-img>

      <EventHeader class="flex-grow-1 mx-6" />
      <v-btn
        width="200px"
        v-if="isBackButton"
        rounded
        style="height: 56px !important"
        color="primary"
        x-large
        class="text-capitalize mr-3"
        :loading="callCenterStore.isChangePage"
        @click="backOrderList"
      >
        <v-icon left>{{ icons.mdiArrowLeft }}</v-icon>
        Geri Dön
      </v-btn>

      <v-btn
        v-if="isOrderButton"
        width="200px"
        rounded
        style="height: 56px !important"
        color="secondary"
        x-large
        :loading="callCenterStore.isChangePage"
        class="text-capitalize mr-3"
        @click="newOrder"
      >
        Sipariş Oluştur
      </v-btn>
      <CustomerMenu />
    </v-app-bar>
    <v-main>
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import { mdiArrowLeft, mdiFileDocumentPlusOutline } from "@mdi/js";
import { useRouter } from "@core/utils";
import { computed } from "@vue/composition-api";
import CustomerMenu from "@/components/TheHeader/CustomerMenu.vue";
import EventHeader from "@/components/TheHeader/EventHeader.vue";
import { useCallCenterStore } from "@/stores/callCenter";

import themeConfig from "@themeConfig";

export default {
  components: {
    CustomerMenu,
    EventHeader,
  },
  setup() {
    const callCenterStore = useCallCenterStore();

    const { route, router } = useRouter();

    const isBackButton = computed(() => {
      let result = false;
      if (route.value.name !== "dashboard-call-center" && !route.value.params.item) {
        result = true;
      }
      return result;
    });

    const isOrderButton = computed(() => {
      let result = false;
      if (route.value.name === "dashboard-call-center" || route.value.params.item) {
        result = true;
      }
      return result;
    });

    const newOrder = () => {
      callCenterStore.isChangePage = true;
      router.push({ name: "call-center-order" });
    };

    const backOrderList = () => {
      callCenterStore.isChangePage = true;
      router.push({ name: "dashboard-call-center" });
    };
    return {
      callCenterStore,
      isBackButton,
      isOrderButton,
      logo: themeConfig.app.iconTextLogo,
      newOrder,
      backOrderList,
      icons: {
        mdiArrowLeft,
        mdiFileDocumentPlusOutline,
      },
    };
  },
};
</script>

<style></style>
